import {isMobile} from "../helpers"
export default () => ({
    init(){
        this.onWindowResize()
    },
    onWindowResize(){
        if(isMobile()){
            // alert(window.innerHeight)
            document.body.style.height=`${window.innerHeight}px`
        }
        //document.body.style.overflow=`hidden`
        //this.$root.style.height=`${window.innerHeight/2}px`
    }
})